import { anyPass, compose, concat, cond, converge, not, T } from 'ramda';

import { isUserAuthenticated } from 'app/features/user/selectors';
import { isNewExperience } from 'app/features/landing/selectors';
import {
  isLandingPath,
  isXboxOfferPath,
  isPricingPromoLandingPath,
  signInLink,
  getSearch,
  isCouponApp,
} from 'app/router/selectors';
import {
  HOME_PATH,
  MIGRATION_LANDING_PATH,
  NEXT,
  XBOX_LANDING_PATH,
} from 'app/router/constants/paths';
import { isMigrationLandingPath } from 'app/features/migration/landing/selectors';

const isLoginVisible = compose(not, isUserAuthenticated);

const isDefaultLanding = converge(
  (isLanding, isNewExperience) => isLanding && !isNewExperience,
  [isLandingPath, isNewExperience],
);

const isRightButtonsVisible = anyPass([
  isDefaultLanding,
  isXboxOfferPath,
  isMigrationLandingPath,
  isPricingPromoLandingPath,
]);

const loginPathWithNextParam = nextParam =>
  converge(
    (signInLink, search) =>
      `${signInLink}?${NEXT}=${encodeURIComponent(nextParam + search)}`,
    [signInLink, getSearch],
  );

const loginPath = cond([
  [isXboxOfferPath, loginPathWithNextParam(XBOX_LANDING_PATH)],
  [isMigrationLandingPath, loginPathWithNextParam(MIGRATION_LANDING_PATH)],
  [isCouponApp, loginPathWithNextParam(HOME_PATH)],
  [T, converge(concat, [signInLink, getSearch])],
]);

export { isLoginVisible, isRightButtonsVisible, loginPath };
